import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'

import { useNotification } from '../../../../../hooks'
import { getViewingProfileLink } from '../../../../RentalPortalViewing'
import { ViewingRescheduleModal } from '../../ViewingRescheduleModal'
import { useViewingProfileContext } from '../useViewingProfileContext'

export function useViewingReschedule() {
  const navigate = useNavigate()

  const { handleAddSuccessNotification } = useNotification()

  const { handleCloseModal, setModal, viewingData } = useViewingProfileContext()

  const [rescheduledViewingId, setRescheduledViewingId] = useState(null)

  function handleRescheduled(viewingId) {
    handleAddSuccessNotification(
      'RentalPortal.ViewingRescheduledNotificationKey'
    )

    setRescheduledViewingId(viewingId)
  }

  function handleOpenReschedule() {
    setModal(
      <ViewingRescheduleModal
        viewingData={viewingData}
        onClose={handleCloseModal}
        onRescheduled={handleRescheduled}
      />
    )
  }

  useEffect(() => {
    if (rescheduledViewingId) {
      navigate(getViewingProfileLink(rescheduledViewingId))
    }
  }, [rescheduledViewingId])

  return { handleOpenReschedule }
}
